export const Deg0 = [0, 0, 0];
export const DoorDeg90CCW = [0, Math.PI / 2, 0];
export const DoorDeg90CW = [0, -Math.PI / 2, 0];
export const HandleDeg45CW = [0, 0, -Math.PI / 4];
export const HandleDeg90CW = [0, 0, -Math.PI / 2];
export const HandleDeg360CCW = [0, 0, 2*Math.PI];
export const BoltClosePos = [0, 0, 0];
export const BoltOpenPosFront = [-0.03, 0, 0];
export const BoltOpenPosBack = [0.03, 0, 0];
export const BoltOpenPosBottom = [0, -0.03, 0];
export const BoltOpenPosTop = [0, 0.03, 0];
export const Scale0 = [0, 0, 0];
export const Scale1 = [1, 1, 1];
